import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestsService } from "./requests.service";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  constructor(private requestService: RequestsService) {}

  upload(formData: FormData): Observable<{
    image_urls?: string[];
    success: boolean;
    image_url?: string;
  }> {
    return this.requestService.dash_post("upload", formData);
  }
}
